/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow-restricted-names */
import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { api } from './api';

const usersAdapter = createEntityAdapter();

const usersInitialState = usersAdapter.getInitialState();

export const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => '/users',
      async onQueryStarted(undefined, { dispatch, queryFulfilled }) {
        dispatch(showLoading());
        try {
          const { data } = await queryFulfilled;
          dispatch(hideLoading());
        } catch (err) {
          dispatch(hideLoading());
        }
      },
      transformResponse: (response) => {
        return usersAdapter.setAll(usersInitialState, response.data.users);
      },
      providesTags: (error, arg, result = []) => [
        'User',
        ...result.map(({ id }) => ({ type: 'User', id })),
      ],
    }),
  }),
});

export const { useGetUsersQuery } = usersApi;

export const selectUsersResult = api.endpoints.getUsers.select();

const selectUsersData = createSelector(
  selectUsersResult,
  (usersResult) => usersResult.data
);

export const { selectAll: selectAllUsers, selectById: selectUserById } =
  usersAdapter.getSelectors(
    (state) => selectUsersData(state) ?? usersInitialState
  );
